import type { ComputedRef } from 'vue'
import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'

type OverlayPage = {
  /** The id in the address bar, or null while the list is showing. */
  id: ComputedRef<string | null>
  open: (id: string, query?: Record<string, string>) => void
  close: () => void
}

/** A detail page over a list that stays mounted; the url is the source of truth, so refresh and shared links still land. */
export function useOverlayPage(options: {
  backLink: string
  viewUrl: (id: string) => string
  idFromPath: (path: string) => string | null
}): OverlayPage {
  const route = useRoute()
  const router = useRouter()

  return {
    id: computed(() => options.idFromPath(route.path)),

    open: (id: string, query?: Record<string, string>) => {
      router.push({ path: options.viewUrl(id), query })
    },

    close: () => {
      router.push(options.backLink)
    },
  }
}
